__turbopack_context__.v({
  "figure": "FirstRunChicky-module__9gdJ3a__figure",
  "frame": "FirstRunChicky-module__9gdJ3a__frame",
  "frames": "FirstRunChicky-module__9gdJ3a__frames",
  "frames-4": "FirstRunChicky-module__9gdJ3a__frames-4",
  "frames-5": "FirstRunChicky-module__9gdJ3a__frames-5",
  "orbit": "FirstRunChicky-module__9gdJ3a__orbit",
  "sprite": "FirstRunChicky-module__9gdJ3a__sprite",
});
